module.exports = __webpack_public_path__ + "img/Copyright_notation.ed20bf15.png";